import padNum from "./padNum";

export function toHoursAndMinutes(date) {
	date = date || new Date();

	return `${padNum(date.getHours(), 2)}:${padNum(date.getMinutes(), 2)}`;
}
